export default __webpack_public_path__ + "static/media/imagePrintContentSix.3602026b.png";